import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['You walk into every session without a clear clinical roadmap', 'You build plans, handouts, and follow-ups from scratch every time', 'Your clinical materials are scattered across PDFs, folders, and random files', 'You repeat the same basic explanations with no structured resource to support you', 'Your consultations feel improvised with no defined clinical criteria', 'You know your practice could look and feel more organized and professional', 'You end the day with more pending work than when you started'];
const after = ['You walk into every session with clinical structure, confidence, and precision', 'You build personalized plans in under 5 minutes without starting from scratch', 'Your entire consultation system is in one place, organized and ready to use', 'You explain complex concepts with clear visual guides your patients actually understand', 'You run follow-ups with real clinical markers beyond just weight', 'Your practice looks and feels premium, organized, and authoritative', 'You end every day with consultations fully resolved and next steps clearly defined'];
export function PainSection() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-139" data-mp="5fao59rftmxf">
      <div className="mx-auto max-w-5xl" data-id="element-140" data-mp="g7qwbhp8l00">
        <div className="mx-auto max-w-2xl text-center" data-id="element-141" data-mp="hiwmgupg2tr">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-142" data-mp="38vrjd8ajpze0">
            Do any of these sound familiar?
          </h2>
          <p className="mt-3 text-sm italic text-dark-green sm:text-base" data-id="element-143" data-mp="33vlm9clibkoj">
            If even one of these resonates, this system was built for you.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-144" data-mp="3dub6hc0vlh7y">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-red-300 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-145" data-mp="2q59trcl0fjwv">
            <h3 className="mb-5 text-lg font-bold text-slate sm:text-xl" data-id="element-146" data-mp="u1c1fclmh8cm">Without the System</h3>
            <ul className="space-y-3" data-id="element-147" data-mp="yu58w88h6use">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-148" data-mp="12vqgpf65kivq">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-149" data-mp="12x1khezllqmu">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-150" data-mp="b3j3yptrpqmm" />
                  </span>
                  <span className="text-sm leading-relaxed text-slate/80" data-id="element-151" data-mp="f54l4ndc4r2m">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-sage bg-[#F0F7ED] p-6 sm:p-8" data-id="element-152" data-mp="k60o8ypv496z">
            <h3 className="mb-5 text-lg font-bold text-dark-green sm:text-xl" data-id="element-153" data-mp="20ogdaw1znxjt">
              With NutriPro Complete System™
            </h3>
            <ul className="space-y-3" data-id="element-154" data-mp="1vw6sfufqdnoe">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-155" data-mp="1rx7r0jt7k91p">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-dark-green" data-id="element-156" data-mp="1mxbl2f0ya7ji">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-157" data-mp="1hxyx1qyceufc" />
                  </span>
                  <span className="text-sm leading-relaxed text-slate/80" data-id="element-158" data-mp="1cydr2wkr9lt4">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}